export default "__VITE_ASSET__D$qMzudx__"